import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { border, borderRadius } from 'styled-system';

import { Flex } from 'common/components/Flex';
import Icon from 'common/components/Reclamation/Icon';
import { focusOutlineCSSWithOffsetAndRadius } from 'common/theme/styles';

const UnstyledButtonSection = styled(Flex)<any>`
  ${border};
  ${borderRadius};

  cursor: pointer;

  ${focusOutlineCSSWithOffsetAndRadius};
`;

const ButtonSection = (props: ComponentProps<typeof UnstyledButtonSection>) => (
  <UnstyledButtonSection
    as="button"
    backgroundColor="transparent"
    border="none"
    p="sp_0"
    borderRadius="medium"
    {...props}
  />
);

interface EditIconButtonProps {
  dataTestId: string;
  onClick: (itemId: string) => void;
  ariaLabel: string;
  isDisabled?: boolean;
}

const EditButton = ({
  dataTestId,
  onClick,
  ariaLabel,
  isDisabled = false,
}: EditIconButtonProps) => (
  <ButtonSection
    data-testid={dataTestId}
    aria-label={ariaLabel}
    disabled={isDisabled}
    onClick={onClick}
  >
    <Icon name="edit" />
  </ButtonSection>
);

export default EditButton;
